module.exports = __webpack_public_path__ + "static/game_room-c697f658ff96429491b4f4bf9b6339f8.jpg";